import { ExplanationTypeEnum } from '@doltech/utils/lib/constants';
import { Instance, types as t } from 'mobx-state-tree';

import { ListeningExplanationStore } from '../../Explanation/_extends/listening-explanation.store';
import { DetailOnlyExplanationStore } from '../../Explanation/_implementations/detail-only-explanation.store';
import { LocatingDetailExplanationStore } from '../../Explanation/_implementations/locating-detail-explanation.store';
import { MainIdeaExplanationStore } from '../../Explanation/_implementations/main-idea-explanation.store';

const getExplanationModelByType = (type) => {
  switch (type) {
    case ExplanationTypeEnum.MAIN_IDEA:
      return MainIdeaExplanationStore;
    case ExplanationTypeEnum.LOCATING_DETAIL:
      return LocatingDetailExplanationStore;
    case ExplanationTypeEnum.LISTENING_EXPLANATION:
      return ListeningExplanationStore;
    case ExplanationTypeEnum.DETAIL_ONLY:
      return DetailOnlyExplanationStore;
    default:
      throw new Error(`Can't resolve passage type ${type}`);
  }
};

export const CorrectOption = t
  .model('CorrectOption', {
    key: t.maybeNull(t.number),
    explanation: t.maybeNull(
      t.union(
        {
          dispatcher: (s) => {
            if (s) {
              return getExplanationModelByType(s.type);
            }
            return MainIdeaExplanationStore;
          },
        },
        MainIdeaExplanationStore,
        LocatingDetailExplanationStore,
        ListeningExplanationStore,
        DetailOnlyExplanationStore
      )
    ),
  })
  .actions((self) => ({
    setKey(key: number) {
      self.key = key;
    },
  }));

export interface CorrectOptionInstance extends Instance<typeof CorrectOption> {}
